import { Component } from '@mycolorway/tao';
import $ from 'jquery';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import { closest } from 'next/javascripts/modules/dom';

Component('tr-repository-whitelist-button', {
  mixins: [eventListenerMixin],

  properties: {
    openListOnReady: {
      type: Boolean,
      default: false,
    },
  },

  ready() {
    this.container = this.querySelector('.container');
    if (this.container) {
      this.header = this.querySelector('.menu-header');
      this.content = this.querySelector('.content');
      this.confirmDialog = this.querySelector('.confirm-remove-dialog');

      this.listenTo(this.content, 'scroll', this.handleContentScroll.bind(this));
      this.listenTo(document, 'click', this.handleClickInContainer.bind(this));
      this.listenTo(this, 'click', (event) => {
        if (closest(event.target, '.close-btn')) {
          this.toggleListOpen(false);
        } else if (closest(event.target, '.remove-all-link')) {
          this.confirmDialog.open();
        } else if (closest(event.target, '.button-icon')) {
          this.toggleListOpen();
        }
      });

      this.toggleListOpen(this.openListOnReady);
    }
  },

  disconnected() {
    this.stopListening();
    this.toggleListOpen(false);
  },

  handleContentScroll(event) {
    if (event.target.scrollTop > 1) {
      $(this.header).addClass('scrolled');
    } else {
      $(this.header).removeClass('scrolled');
    }
  },

  toggleListOpen(open) {
    this.classList.toggle('active', open);
  },

  handleClickInContainer(event) {
    if (closest(event.target, 'tr-repository-whitelist-button')) return;
    if (closest(event.target, '.whitelist-dialog')) return;
    if (closest(event.target, '.confirm-remove-dialog')) return;
    this.toggleListOpen(false);
  },
});
